export default "__VITE_ASSET__BSOPjQtL__"